import TabStackLayout from '@/views/layouts/TabStackLayout'

export default function SearchLayout() {
  return <TabStackLayout title="搜索" />
}
